import {
  mdiCommentMultipleOutline,
  mdiContacts,
  mdiRobotOutline,
  mdiLockOpenOutline,
} from '@mdi/js'

export default [
  {
    title: 'Customer License',
    icon: mdiCommentMultipleOutline,
    children: [
      {
        title: 'Dashboard',
        to: 'customer-licence-dashboard',
      },
      {
        title: 'User Plans',
        to: 'user-plans',
      },
    ],
  },
  {
    title: 'Support',
    icon: mdiContacts,
    children: [
      {
        title: 'Dashboard',
        to: 'admin-dashboard',
      },
      {
        title: 'Knowledge-Base',
        to: 'knowledge-base',
      },
      {
        title: 'Support Tickets',
        to: 'admin-support',
      },
      {
        title: 'Escalation ',
        to: 'escalation',
      },
    ],
  },
  {
    title: 'AI Estimate Request',
    to: 'customer-request',
    icon: mdiRobotOutline,
  },
  {
    title: 'Request Access',
    to: 'request-access',
    icon: mdiLockOpenOutline,
  },
]
